import React, { ReactNode } from "react";
import { Button, ButtonProps, Typography } from "@mui/material";

import { SearchInputProps } from "../../../../../";

import { BaseFilterButton, type BaseFilterButtonProps } from "../button";

type TitleSlotProps = {
  label: string;
};

type ContentSlotProps = {
  searchValue?: string;
};

type ActionsSlotProps = ButtonProps & {
  onClick?: () => void;
  hasChanges?: boolean;
};

export type FilterSlotProps = {
  title?: TitleSlotProps;
  content?: ContentSlotProps;
  actions?: ActionsSlotProps;
  searchInput?: Partial<SearchInputProps>;
  button?: Partial<BaseFilterButtonProps>;
};

export type FilterSlots = {
  button?: (props: Required<FilterSlotProps>["button"]) => ReactNode;
  title?: (props: Required<FilterSlotProps>["title"]) => ReactNode;
  content?: (props: Required<FilterSlotProps>["content"]) => ReactNode;
  actions?: (props: Required<FilterSlotProps>["actions"]) => ReactNode;
};

export const defaultSlots: Required<FilterSlots> = {
  button: (props) => <BaseFilterButton {...props} label={props.label || ""} />,
  title: ({ label }) => <Typography variant="body2">{label}</Typography>,
  content: () => null,
  actions: ({ onClick, hasChanges, ...rest }) => {
    if (!hasChanges) return null;
    return (
      <Button variant="contained" onClick={onClick} size="small" {...rest}>
        Apply
      </Button>
    );
  },
};
